export {
  default as kiddiePool,
  ReactComponent as KiddiePool,
} from '@assets/icons/features-and-amenities/kiddie-pool.svg'    
